import { render, staticRenderFns } from "./ModalCourierNotFound.vue?vue&type=template&id=8937e278&"
import script from "./ModalCourierNotFound.vue?vue&type=script&lang=ts&"
export * from "./ModalCourierNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports